module.exports = __webpack_public_path__ + "img/317.01c8f85b.png";